import { useState } from 'react';
import { get } from 'lodash';
import * as API from '../api';

const useOktaApi = () => {
    const [data, setData] = useState({
        enabled: false,
        isLoading: true,
        error: null,
    });

    const fetchOkta = async () => {
        setData((state) => ({
            ...state,
            isLoading: true,
            error: null,
        }));
        try {
            const result = await API.isOktaActive();
            const enabled = get(result, 'data.success', false);

            setData((state) => ({
                ...state,
                enabled,
                isLoading: false,
            }));

            return enabled;
        } catch (e) {
            setData((state) => ({
                ...state,
                isLoading: false,
                error: e,
            }));

            return null;
        }
    };

    return [
        {
            ...data,
        },
        { fetchOkta },
    ];
};

export default useOktaApi;
